import {
  fetchCollection
} from './index'

import { msdsSheetSchema as schema } from '../schemas'

const multipleKey = 'msdsSheets'

export const MSDS_SHEETS_REQUEST = 'MSDS_SHEETS_REQUEST'
export const MSDS_SHEETS_SUCCESS = 'MSDS_SHEETS_SUCCESS'
export const MSDS_SHEETS_FAILURE = 'MSDS_SHEETS_FAILURE'

export function fetchMSDSSheets () {
  return fetchCollection({
    url: `/msds_sheets`,
    key: multipleKey,
    actions: [MSDS_SHEETS_REQUEST, MSDS_SHEETS_SUCCESS, MSDS_SHEETS_FAILURE],
    schema
  })
}



// WEBPACK FOOTER //
// ./src/actions/msds-sheets.js